import { Component, Input, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { PlotBands } from 'components/event-graph/event-graph';
import { SleepService } from './../../providers/sleep.service';
import { takeUntil } from 'rxjs/operators';
import { AbstractComponent } from './../abstract-component';
import { ToastService } from './../../providers/toast.service';

/**
 * Generated class for the SleepInputViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sleep-input-view',
  templateUrl: 'sleep-input-view.html'
})
export class SleepInputViewComponent extends AbstractComponent {

  @Input() user: any;
  // 範囲指定開始日時
  @Input() rangeStart: number;
  // 範囲指定終了日時
  @Input() rangeEnd: number;

  selectedRange: {start: number, end: number} = { start: null, end: null };

  isMobile: boolean = false;

  plotBands: PlotBands[];

  // 10分毎 144個
  // series = Array.from(Array(144).keys()).map(i =>  .5);
  // pointInterval = 60 * 1000 * 10;

  // 5分毎 288個*2日分 48時間表示するため
  series = Array.from(Array(576).keys()).map(i =>  .5);
  pointInterval = 60 * 1000 * 5;

  // 1分毎 1440個
  // series = Array.from(Array(1440).keys()).map(i =>  .5);
  // pointInterval = 60 * 1000;

  // 範囲未選択欄の色
  // bgColor = '#fbf1dc';
  bgColor = '#F9F9F9';
  bgColorSelected = '#ed230c80';

  // 入力対象
  target: 'sleep' |  'wakeup' = null;

  constructor(
    private sleepService: SleepService,
    private toastService: ToastService
  ) {
    super();
    console.log('Hello SleepInputViewComponent Component');
    const ua = navigator.userAgent;
    if((ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) || ua.indexOf('iPad') > 0) {
      this.isMobile = true;
    }
  }

  ngOnInit() {

    this.plotBands = [{ // mark the weekend
      id: `id-${this.user.patientId}`,
      color: this.bgColor,
      from: this.rangeStart,
      to: this.rangeEnd,
      zIndex: 1,
    }];

    if (this.user.sensorRecords && this.user.sensorRecords.length > 0) {

      this.user.sensorRecords.forEach((record, idx, arr) => {

        let color = '#F9F9F9';
        switch (record.state) {
          // 覚醒
          case 'sitting': case 'up': case 'wake': case 'endmost':
            // color = '#f71570';
            // color = '#f5c310'
            color = '#F2DB99'
            break;
          // 寝ているとき/目覚めかけも寝ていると判断
          case 'sleep': case 'middle':
            // color = '#043985';
            color = '#A0CBEB';
            break;
          case 'off':
            // color = '#808080';
            color = '#E4E4E4'
            break;
          default:
            break;
        }

        // スタート ~ エンドを作成したいため、最後のレコードはスルー
        if (idx === arr.length - 1) {
          return;
        }
        this.plotBands.push({
          id: `id-` + record._id,
          color: color,
          from: record.time? record.time * 1000: null,
          to: arr[idx + 1].time? arr[idx + 1].time * 1000: null,
          zIndex: 1,
        });
      })
    }

    if (this.user.sleepAt) {
      this.selectedRange.start = this.user.sleepAt;
    }
    if (this.user.wakeupAt) {
      this.selectedRange.end = this.user.wakeupAt;
    }

    // 登録完了処理
    this.sleepService.regist$.pipe(takeUntil(this.onDestroy$)).subscribe(result => {
      if (result && result.data.patient === this.user.patientId) {
        this.toastService.basic(`${this.user.name}さんの睡眠時間を登録しました`, 3000, 'top');
        this.user.sleepRecordId = result.data._id,
        this.user.sleepAt = this.selectedRange.start;
        this.user.wakeupAt = this.selectedRange.end;
      }
    });

    // 更新完了処理
    this.sleepService.update$.pipe(takeUntil(this.onDestroy$)).subscribe(result => {
      if (result && result.data.patient === this.user.patientId) {
        this.toastService.basic(`${this.user.name}さんの睡眠時間を更新しました`, 3000, 'top');
        this.user.sleepAt = this.selectedRange.start;
        this.user.wakeupAt = this.selectedRange.end;
      }
    });
      
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.user) {
    //   this.target = changes.target.currentValue;
    // }
    console.log({user: changes.user});
  }


  clear(key: string) {
    this.selectedRange[key] = null;
  }

  changeRange($event) {
    this.selectedRange = $event;
  }

  /**
   * 入力対象の選択
   * @param key
   */
  focus(key: 'sleep' |  'wakeup') {
    this.target = key;
  }

  /**
   * 登録処理
   */
  send() {

    if (!this.selectedRange.start && !this.selectedRange.end) {
      alert('就寝時間 または 起床時間を選択して登録して下さい');
      return false;
    }

    if (!confirm('一度保存すると変更できません。保存して良いですか？')) return false;

    // 新規登録
    if (!this.user.sleepAt && !this.user.wakeupAt) {
      this.sleepService.regist({
        ...this.user,
        dateAt: moment(this.rangeEnd).format('YYYY-MM-DD'),
        sleepAt: this.selectedRange.start, 
        wakeupAt: this.selectedRange.end
      });
      return;
    }
    // 更新処理
    this.sleepService.update({
      _id: this.user.sleepRecordId,
      sleepAt: this.selectedRange.start, 
      wakeupAt: this.selectedRange.end
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/sleep-input-view/sleep-input-view.ts